import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Router, Event, NavigationStart, NavigationEnd } from '@angular/router';
import { environment } from '../../../environments/environment';

import { RootScopeService } from '../shared-service/root-scope.service';
import { RootScopeDeclare } from '../rootscope-declare';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  cloudBasePath: string;
  currentRoute: string;

  @Input() isAuthSuccess: boolean;

  constructor(
    private rootScopeService: RootScopeService,
    private router: Router,
    private changeDetector: ChangeDetectorRef
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
      }

      if (event instanceof NavigationEnd) {
        this.currentRoute = this.router.url;
      }
    });
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => (this.rootScopeData = rootScopeData));
  }

  ngOnInit() {
    this.getRootScopeData();
    this.cloudBasePath = environment.cloudBasePath;
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }
}
